import type { ICianMFUIElement } from '@cian/mf-registry/browser';
import * as React from 'react';

interface IUseAdBannerMicrofrontendResult {
  microfrontendRef: React.MutableRefObject<ICianMFUIElement | null>;
  isReady: boolean;
}

/**
 * Монтирует микрофронтенд только на клиенте: `isReady` переключается в `true` через
 * `setTimeout(..., 0)` после маунта, чтобы реклама не рендерилась на SSR.
 */
export function useAdBannerMicrofrontend(): IUseAdBannerMicrofrontendResult {
  const microfrontendRef = React.useRef<ICianMFUIElement | null>(null);
  const [isReady, setIsReady] = React.useState(false);

  React.useEffect(() => {
    const timeoutId = setTimeout(() => setIsReady(true), 0);

    return () => clearTimeout(timeoutId);
  }, []);

  return { microfrontendRef, isReady };
}
